import NextLink from 'next/link';

export default function Info({ challenges, filtered }) {
  return (
    <div className="flex flex-wrap gap-x-5 gap-y-3 justify-between text-sm w-full">
      <p className="text-neutral-500">
        Showing {filtered.length} of {challenges.length} challenges
      </p>

      <p className="text-neutral-500">
        <span className="hidden tablet:inline">Not sure where to start?</span>{' '}
        <NextLink
          className="text-blue-500 underline hover:no-underline"
          href="/learning-paths"
        >
          Try our learning paths
        </NextLink>
      </p>
    </div>
  );
}
